import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import ReactionPill from 'srcReact/components/common2/ReactionContainer/components/ReactionPill'
import Avatar from 'srcReact/components/common2/Avatar'
import { useTranslation } from 'react-i18next'

export default function ReactionPopup({ reaction, loggedInUserReacted, closeModal }) {
  const users = reaction ? reaction.users : []
  const { t } = useTranslation()

  return (
    <div className={styles.reactionContainer}>
      {reaction && (
        <ReactionPill
          reactionCode={reaction.unified_unicode}
          variant={loggedInUserReacted ? 'green' : 'gray'}
          count={users ? users.length : ''}
        />
      )}

      <div className={styles.list}>
        {users &&
          users.length > 0 &&
          users.map((user) => {
            return (
              <div key={user.id} className={styles.user}>
                <Avatar
                  showUserName={false}
                  key={'member_' + user.id}
                  userId={user.id}
                  profilePicture={user.profile_picture_url}
                  firstname={user.firstname}
                  lastname={user.lastname}
                  imgWrapperSize='small'
                  mimeType={user.mime_type}
                  originalTag={user.original_tag}
                  isOriginal={user.is_original}
                  status={user.status}
                  withExpertiseGroup={user.with_expertise_group}
                />
                <div className={styles.username}>{`${user.firstname} ${user.lastname}`}</div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
